import { render } from "./PixelArtCardPublic.vue?vue&type=template&id=e07ec8ba&scoped=true"
import script from "./PixelArtCardPublic.vue?vue&type=script&lang=js"
export * from "./PixelArtCardPublic.vue?vue&type=script&lang=js"

import "./PixelArtCardPublic.vue?vue&type=style&index=0&id=e07ec8ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e07ec8ba"]])

export default __exports__